import { useState } from 'react';
import './PriceRangeFilter.css';

interface PriceRangeFilterProps {
  minPrice?: number;
  maxPrice?: number;
  onPriceChange: (min?: number, max?: number) => void;
  currency?: string;
}

const PriceRangeFilter: React.FC<PriceRangeFilterProps> = ({
  minPrice: initialMin,
  maxPrice: initialMax,
  onPriceChange,
  currency = 'TWD'
}) => {
  const [minPrice, setMinPrice] = useState(initialMin?.toString() || '');
  const [maxPrice, setMaxPrice] = useState(initialMax?.toString() || '');

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setMinPrice(value);
    const min = value ? Number(value) : undefined;
    const max = maxPrice ? Number(maxPrice) : undefined;
    onPriceChange(min, max);
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setMaxPrice(value);
    const min = minPrice ? Number(minPrice) : undefined;
    const max = value ? Number(value) : undefined;
    onPriceChange(min, max);
  };

  const handleClear = () => {
    setMinPrice('');
    setMaxPrice('');
    onPriceChange(undefined, undefined);
  };

  return (
    <div className="price-range-filter">
      <label className="price-range-filter__label">
        價格區間 ({currency})
      </label>
      <div className="price-range-filter__inputs">
        <input
          type="number"
          className="price-range-filter__input"
          placeholder="最低價"
          value={minPrice}
          onChange={handleMinChange}
          min="0"
        />
        <span className="price-range-filter__separator">-</span>
        <input
          type="number"
          className="price-range-filter__input"
          placeholder="最高價"
          value={maxPrice}
          onChange={handleMaxChange}
          min="0"
        />
        {(minPrice || maxPrice) && (
          <button
            className="price-range-filter__clear"
            onClick={handleClear}
            type="button"
          >
            清除
          </button>
        )}
      </div>
    </div>
  );
};

export default PriceRangeFilter;
